import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";

const Dropdown = ({
  label,
  options = [],
  value = "",
  onChange,
  size = "medium",
  multiple = false,
}) => {
  const renderValue = (selected) => {
    if (multiple) {
      const selectedLabels = options
        .filter((option) => selected.includes(option.value))
        .map((option) => option.label);
      return selectedLabels.join(", ");
    } else {
      const selectedOption = options.find((option) => option.value === selected);
      return selectedOption?.label || "";
    }
  };

  return (
    <FormControl sx={{ width: "15rem" }} size={size}>
      <InputLabel>{label}</InputLabel>
      <Select
        multiple={multiple}
        value={value}
        onChange={onChange}
        label={label}
        renderValue={renderValue}
        sx={{ backgroundColor: "white" }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {multiple ? (
              <>
                <Checkbox checked={value.includes(option.value)} />
                <ListItemText primary={option.label} />
              </>
            ) : (
              option.label
            )}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default Dropdown;
